import React from 'react';
import BotIcon from '../../assets/bot_icon.png';
import MainIcon from '../../assets/maruti_main.png';
import { MSILChatBot } from '../../utility/msilChatbot';

const getIdTokenKey = () => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (
      key.startsWith('CognitoIdentityServiceProvider.') &&
      key.endsWith('.idToken')
    ) {
      // console.log('key', key);
      return key;
    }
  }
};

const Chatbot = () => {
  // This is written as from constants file was not reading the value of msilChatbotUrl
  // const ApiUrl = 'https://d3mfny6hh1kkyh.cloudfront.net/beta/chat';
  const ApiUrl =
    'https://ovoki435irxau5mw6tvq7szuiy0sgelo.lambda-url.ap-south-1.on.aws/chat';

  const Token = getIdTokenKey();
  // console.log('ApiUrl', ApiUrl);
  return (
    <div className='AppChatBot'>
      <MSILChatBot
        BotIcon={BotIcon}
        MainIcon={MainIcon}
        ApiUrl={ApiUrl}
        Token={Token}
      />
    </div>
  );
};

export default Chatbot;
